export default __webpack_public_path__ + "static/media/background.acf818f5.png";